import DashboardPage from '@components/pages/dashboard'
import { TableWrapper } from '@/ui/components/CustomTable/CustomTable.styles'
import Typography from '@/ui/components/typography'
import { InlineScanIndicator } from '@/ui/components/inline-scan-indicator'
import { TitleWrapper } from '@routes/digital-footprint/routes/assets/assets.styles'
import { AssetsExport } from '@routes/digital-footprint/routes/assets/components/assetExport'
import { useUsersPage } from './hooks/useUsersPage'
import { UsersTable } from './components/usersTable'
import { UsersHeader } from './components/usersHeader'
import { CloudAppIntegrationsTable } from './components/cloudAppIntegrationsTable'
import { UsersSkeleton } from './components/usersSkeleton'
import { CloudAppSection } from './users.route.styles'

const UsersPage = () => {
    const {
        loading,
        filteredUsers,
        cloudAppAssets,
        scanInProgress,
        emptyUsersMessage,
    } = useUsersPage()

    return (
        <DashboardPage
            name="users"
            loading={loading}
            hideScanInProgress
            skeleton={<UsersSkeleton />}
        >
            <TableWrapper>
                <TitleWrapper>
                    <Typography variant="m-regular">Users Assets</Typography>
                    <AssetsExport
                        assets={[...filteredUsers, ...cloudAppAssets]}
                        exportScope="users"
                        scanInProgress={!!scanInProgress}
                    />
                    <InlineScanIndicator scanInProgress={!!scanInProgress} />
                </TitleWrapper>
                <CloudAppSection>
                    <Typography
                        variant="m-regular"
                        className="cloud-app-integrations-title"
                        data-testid="cloud-app-integrations-title"
                    >
                        Cloud App Integrations
                    </Typography>
                    <CloudAppIntegrationsTable />
                </CloudAppSection>
                <UsersHeader />
                <UsersTable
                    assets={filteredUsers}
                    emptyUsersMessage={emptyUsersMessage}
                />
            </TableWrapper>
        </DashboardPage>
    )
}

export default UsersPage
